import React, { useState, useEffect, useRef } from 'react';

import DropdownList from '../DropdownList/DropdownList';
import './statsClientFilterForm.css';

export default function StatsClientFilterForm({ clients, setClients, closeForm }) {
  const formRef = useRef(null);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(
      clients
        .map(client => ({ value: client.client, selected: false }))
        .sort((a, b) => a.value.localeCompare(b.value))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        closeForm();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeForm]);

  const handleValidateSelection = () => {
    setClients(prevClients =>
      prevClients.map(client => {
        const newClient = filteredData.find(
          filteredClient => filteredClient.value === client.client
        );
        return newClient ? { ...client, selected: newClient.selected } : client;
      })
    );
    closeForm();
  };

  return (
    <div ref={formRef} className="filter-form stats-client-filter-form">
      <DropdownList
        isLoading={false}
        data={filteredData}
        setData={setFilteredData}
        dataType="string"
        handleClick={null}
        multiSelectable={true}
        handleValidateSelection={handleValidateSelection}
      />
    </div>
  );
}
